export default function notificationsReducer(state = {}, action) {
  switch (action.type) {
    case "NOTIFICATIONS_FETCHED":
    case "NOTIFICATION_FETCHED":
    case "NOTIFICATION_UPDATED":
    case "NOTIFICATIONS_USERS_FETCHED":
    case "NOTIFICATIONS_USER_FETCHED":
    case "NOTIFICATIONS_USERS_UPDATED":
    case "NOTIFICATIONS_USERS_PAGE_FETCHED":
      return { ...state, ...action.entities.notifications };
    default:
      return state;
  }
}
